<template>
  <div class="view model-view">
    <transition name="view__sidebartransition">
      <model-sidebar v-if="!sidebarClosed" />
    </transition>

    <div class="main">
      <model-net />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ModelSidebar from "./ModelSidebar.vue";
import ModelNet from "@editor/views/model/ModelNet.vue";

import { useModelCopyPaste } from "./modelCopyPaste";
import { useNetStore } from "@editor/net/net.store";

defineOptions({
  name: "ModelView"
});

useModelCopyPaste();

const netStore = useNetStore();


const sidebarClosed = computed(() => netStore.sidebarClosed);
</script>

<style lang="scss"></style>
